var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-detail" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.trendyolStoreIntegrationDetail"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(
            _vm._s(_vm.$t("message.configureTrendyolStoreIntegrationDetail"))
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.channelName")))]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("message.channelName"),
                  name: "channelName",
                },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolSellerIdLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("message.trendyolSellerIdPlaceholder"),
                },
                model: {
                  value: _vm.clone.payload.sellerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "sellerId", $$v)
                  },
                  expression: "clone.payload.sellerId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolApiKeyFieldLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t("message.trendyolApiKeyPlaceholder"),
                },
                model: {
                  value: _vm.clone.payload.apiKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "apiKey", $$v)
                  },
                  expression: "clone.payload.apiKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.trendyolApiSecretKeyLabel"))),
              ]),
              _vm._v(" "),
              _c("a-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "message.trendyolApiSecretKeyPlaceholder"
                  ),
                },
                model: {
                  value: _vm.clone.payload.apiSecretKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "apiSecretKey", $$v)
                  },
                  expression: "clone.payload.apiSecretKey",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer mt-5" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }